
import { Context } from '@nuxt/types'
import { mapGetters } from 'vuex'
import MachinationsLightPage from '~/domain/pages/MachinationsLightPage'
import { IWpRawPost, IWpDetailedPost } from '@interfaces/WpTypes'

export default MachinationsLightPage.extend({
  name: 'BlogAuthorPage',
  layout: 'machinations',
  head() {
    // @ts-ignore
    const pageHead = this.pageHead()
    return {
      ...pageHead,
      // @ts-ignore
      title: `${this.$t('wordCapitalAuthor')}: ${pageHead.title}`,
      meta: [
        {
          hid: 'og:description',
          name: 'og:description',
          content: `Working on content and communities at Machinations, ${pageHead.title} is here to help our members to learn, engage, and discuss anything related to games design.`,
        },
        {
          hid: 'description',
          name: 'description',
          content: `Working on content and communities at Machinations, ${pageHead.title} is here to help our members to learn, engage, and discuss anything related to games design.`,
        },
        ...pageHead?.meta,
      ],
    }
  },
  computed: {
    wpBusy() {
      return this.$store.state.wp.isBusy
    },
    wpPosts(): IWpDetailedPost[] | IWpRawPost[] {
      return this.$store.state.wp.posts
    },
    wpAuthor() {
      return this.$store.state.wp.author
    },
    wpAuthorSlug() {
      return this.$store.state.wp.author?.slug
    },
    ...mapGetters({
      wpPagination: 'wp/wpPagination',
    }),
  },
  methods: {
    async pageChanged(pageNumber: number) {
      if (pageNumber !== 1) {
        this.$router.push(
          `/articles/author/${this.wpAuthorSlug}/page/${pageNumber}`
        )
      }
    },
  },
  async asyncData(context: Context): Promise<void> {
    const { store, params } = context
    const { slugAuthor } = params

    await store.dispatch('common/setupPageLight', { context })
    store.commit('wp/setPageNumber', 1)
    await store.dispatch('wp/resetSelectedCategory')
    await store.dispatch('wp/getCategories', context)

    await store.dispatch('wp/getUserPosts', {
      context,
      slugUser: slugAuthor,
    })
  },
})
